import { recommendationConfig } from "../config";
import { DEFAULT_PAYLOAD } from "../constants";
import { RecommendedType } from "../enums";
import { apiRequest } from "../lib/api.service";
import { GetRecommendatioProps } from "../types/interface.types";
import { RecommendationModel } from "../types/model.types";
import { fetchDataFromCookies } from "../utlis/cookies.util";
import { buildQueryParams } from "../utlis/helper.service";

export async function fetchRecommendations(
  request: GetRecommendatioProps,
): Promise<RecommendationModel> {
  const config = recommendationConfig[request.type];
  const queryParams = buildQueryParams({...DEFAULT_PAYLOAD, filters: request?.jsonFilters});
  const { endPoint, recommendedType, recommendationVariant } = config;
  const userId = request?.userId ?? fetchDataFromCookies().id ?? 'default-segment';
  const productId = request?.productId;
  const token = request?.accesstoken ?? fetchDataFromCookies().token;
  const path = `${endPoint}${recommendedType}/${recommendationVariant}/${recommendedType === RecommendedType.PRODUCT_BASED ? productId : userId}/`;
  const url = `${path}?${queryParams}`;
  console.log("url", url);

  const data = await apiRequest<RecommendationModel>(url, {
    method: "GET",
    accessToken: request?.accesstoken ?? token,
  });
  return data;
}
